import apiCore from '../../utils/api-core';

export function getSecurityStats() {
    return apiCore.get('/api/v3/security/stats');
}

export function getActiveUsers(params) {
    return apiCore.get('/api/v3/security/active-users', { params });
}

export function getLoginHistory(params) {
    return apiCore.get('/api/v3/security/login-history', { params });
}

export function unlockAccount(username) {
    return apiCore.post('/api/v3/security/unlock', { username });
}
